import React, { useState, useEffect } from 'react';

// Inline JSON data
const appData = {
  bookDetails: {
    bookTitle: "Root to Cure",
    bookSubtitle: '"সুস্থতার মূলমন্ত্র"',
    authorName: "Prof. Dr. Mojibul Haque",
    bookDescription: "Root to Cure reflects a transformative journey, blending modern science, spiritual wisdom, and integrative and functional medicine practices to inspire a new model of health and wellness.",
    bookCoverImage: "https://i.postimg.cc/ry13GbGT/Root-to-cure-Book-Mockup-1.png",
    authorImage: "https://drhaque.net/uploads/home-spcialize/1731072207__Haq-1.webp"
  },
  eventDetails: {
    eventDate: "Friday, August 1, 2025",
    eventTime: "6:00 PM EST",
    eventVenue: "Marriott LaGuardia, Queens, New York, USA",
    specialGuests: "City Mayor, Artist, Journalist, Doctors, and Bangladeshi community Leaders!",
    qrCodePlaceholder: "https://i.postimg.cc/GhdX7wZk/Untitled-1.png"
  },
  youtubeVideos: [
    { id: "video1", title: "Million Dollar Advice", url: "https://youtu.be/KaXxOEXNFhg?si=UB-GktVbecYWNQY_" },
    { id: "video2", title: "Documentary About Dr. Haque.", url: "https://youtu.be/T3VQCKo5H-o?si=Vp3BU8b5Wa6E5keF" }
  ],
  socialMediaLinks: [
    { name: "Facebook", url: "https://www.facebook.com/dr.haque.nd.phd/", iconPath: "M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33V22C18.343 21.128 22 16.991 22 12z" },
    { name: "YouTube", url: "https://www.youtube.com/@DrHaqueNDPhD", iconPath: "M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.39.232-4.66 2.653-4.66 2.653S-.04 10.437 0 12.001c.04 1.563 1.285 4.167 4.72 4.399 3.604.246 11.631.245 15.23 0 3.39-.232 4.66-2.653 4.66-2.653s.04-7.185-.04-8.749c-.04-1.563-1.285-4.167-4.72-4.399zM9.545 15.545V8.455L15.455 12l-5.91 3.545z" },
    { name: "Twitter", url: "https://x.com/DrMojibulHaque", iconPath: "M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.41-4.293 4.106 4.106 0 001.27 5.477A4.072 4.072 0 014 9.659v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" },
    { name: "Instagram", url: "https://www.instagram.com/drhaquendphd", iconPath: "M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.024.06 1.379.06 3.808v.63c0 2.43-.013 2.784-.06 3.808-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.024.048-1.379.06-3.808.06h-.63c-2.43 0-2.784-.013-3.808-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.921 2.013 9.276 2 11.705 2h.63zm-.005 3.865a6.148 6.148 0 00-6.148 6.149v.005a6.148 6.148 0 006.148 6.149h.005a6.148 6.148 0 006.149-6.148v-.005a6.148 6.148 0 00-6.148-6.149h-.006zm-.006 1.835a4.312 4.312 0 110 8.624 4.312 4.312 0 010-8.624zm0 2.907a1.405 1.405 0 100 2.81 1.405 1.405 0 000-2.81z" }
  ],
  bookHighlights: [
    { title: "রোগের মূল কারণ", description: "প্রসেসড ফুড, অন্ত্রের ভারসাম্যহীনতা, টক্সিন, চিনি, জীবনযাপন — রোগের মূল কারণ বিশ্লেষণ।" },
    { title: "সমন্বিত চিকিৎসার দর্শন", description: "শরীর-মন-আত্মার সংযোগ এবং সমন্বিত চিকিৎসা দর্শন।" },
    { title: "সুস্থতা অর্জনের ১৩টি জরুরি বিষয়", description: "সুস্থতা অর্জনের জন্য প্রতিটি মানুষের জানা জরুরি এমন ১৩টি বাস্তব বিষয়।" },
    { title: "সুস্থ জীবনের ৪টি স্তম্ভ", description: "পুষ্টি, শরীরচর্চা, ঘুম ও আত্মিক সংযোগ — সুস্থ জীবনের ৪টি স্তম্ভ।" },
    { title: "খাদ্যই আপনার ওষুধ", description: "খাদ্যই হতে পারে আপনার ওষুধ — সঠিক খাদ্যাভ্যাসের গুরুত্ব।" },
    { title: "কার্যকর ফাংশনাল খাবার ও সাপ্লিমেন্টস", description: "নতুন ধরনের কার্যকর ফাংশনাল খাবার ও সাপ্লিমেন্টস।"},
    { title: "রিজেনারেটিভ থেরাপি", description: "স্টেম সেল ও আধুনিক রিজেনারেটিভ থেরাপির ব্যবহার।"},
    { title: "১০টি গুরুত্বপূর্ণ হেলথ টেস্ট", description: "সুস্থতার জন্য সবচেয়ে গুরুত্বপূর্ণ ১০টি হেলথ টেস্ট।"},
    { title: "রোগের মূল কারণ প্রতিরোধের কৌশল", description: "রোগের মূল কারণগুলো প্রতিরোধ ও ফিরে যাওয়ার কার্যকর কৌশল।"},
    { title: "সুস্থতা অর্জনের প্রোগ্রাম (১ম ও ২য় পর্ব)", description: "দুই ধাপে সুস্থতা অর্জনের জন্য বাস্তবসম্মত ও বৈজ্ঞানিক কর্মসূচি।"}
  ],
  contactInfo: {
    registrationLink: "https://forms.gle/VBJnHtx4sMnqKCTp6",
    contactNumber: "+1 430-234-1014",
    contactEmail: "info@integmeds.com"
  },
  quickLinks: [
    { name: "Home", href: "#" },
    { name: "About", href: "#about-book" },
    { name: "Highlights", href: "#highlights" },
    { name: "Author", href: "#author" },
    { name: "Event", href: "#event-details" },
    { name: "Videos", href: "#videos" },
    { name: "Register", href: "#register" },
    { name: "Contact", href: "#contact" }
  ]
};


// ThemeSwitcher Component with improved animation
const ThemeSwitcher = ({ theme, toggleTheme }) => {
  return (
    <button
      onClick={toggleTheme}
      className="p-2 rounded-full bg-gradient-to-br from-gray-200 to-gray-300 dark:from-gray-700 dark:to-gray-800 text-gray-800 dark:text-gray-200 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 flex items-center justify-center"
      aria-label="Toggle dark mode"
    >
      {theme === 'light' ? (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v1m0 16v1m9-9h1M3 12H2m15.325-4.575l.707-.707M6.975 17.675l-.707.707M16.975 6.975l.707-.707M6.325 17.025l-.707.707M12 17a5 5 0 100-10 5 5 0 000 10z" />
        </svg>
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
          <path strokeLinecap="round" strokeLinejoin="round" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
        </svg>
      )}
    </button>
  );
};

// Floating Navigation Component
const FloatingNav = ({ quickLinks, currentColors }) => {
  const [visible, setVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setVisible(false);
      } else {
        setVisible(true);
      }
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    // Adjusting visibility for larger screens: hidden on md and up, only visible on small screens
    <div className={`fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50 transition-all duration-300 md:hidden ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
      <div className="flex items-center bg-white dark:bg-gray-800 rounded-full shadow-xl px-4 py-2 border border-gray-200 dark:border-gray-700">
        {quickLinks.slice(0, 5).map((link) => (
          <a
            key={link.name}
            href={link.href}
            className="px-3 py-1 text-sm font-medium rounded-full hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 mx-1"
            style={{ color: currentColors.text }}
          >
            {link.name}
          </a>
        ))}
      </div>
    </div>
  );
};

// Main Home Component
function Home() {
  // Destructure data from the inline appData object
  const { bookDetails, eventDetails, youtubeVideos, socialMediaLinks, bookHighlights, contactInfo, quickLinks } = appData;

  // --- Dark/Light Mode Implementation ---
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme) {
      return savedTheme;
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  });

  useEffect(() => {
    const root = window.document.documentElement;
    if (theme === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
    localStorage.setItem('theme', theme);
  }, [theme]);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = (e) => {
      if (!localStorage.getItem('theme')) {
        setTheme(e.matches ? 'dark' : 'light');
      }
    };
    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };

  // Gradient-based color scheme
  const lightModeColors = {
    background: '#f8fafc',
    primary: '#0f766e',   // Teal-700
    secondary: '#0d9488', // Teal-600
    accent: '#14b8a6',    // Teal-500
    text: '#334155',      // Slate-700
    cardBg: '#ffffff',
    border: '#e2e8f0',
    gradient: 'linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 50%, #f0fdfa 100%)',
  };

  const darkModeColors = {
    background: '#0f172a',
    primary: '#2dd4bf',   // Teal-400
    secondary: '#5eead4', // Teal-300
    accent: '#99f6e4',    // Teal-200
    text: '#e2e8f0',
    cardBg: '#1e293b',
    border: '#334155',
    gradient: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 50%, #0f172a 100%)',
  };

  const currentColors = theme === 'light' ? lightModeColors : darkModeColors;

  return (
    <div className="min-h-screen font-sans antialiased transition-colors duration-500" style={{
      backgroundColor: currentColors.background,
      color: currentColors.text,
      backgroundImage: currentColors.gradient
    }}>
      {/* Navbar with glass morphism effect */}
      <nav className="fixed w-full z-50 backdrop-blur-md bg-white/80 dark:bg-gray-900/80 border-b border-gray-200 dark:border-gray-800">
        <div className="container mx-auto px-4 py-3 flex justify-between items-center">
          <div className="flex items-center space-x-4">
            <div className="w-8 h-8 rounded-full" style={{ backgroundColor: currentColors.primary }}></div>
            <h1 className="text-xl font-bold tracking-tight" style={{ color: currentColors.primary }}>{bookDetails.bookTitle}</h1>
          </div>
          <div className="flex items-center space-x-4">
            {/* Desktop navigation links: visible on md and up */}
            <div className="hidden md:flex space-x-6">
              {quickLinks.slice(0, 5).map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-sm font-medium hover:opacity-80 transition-opacity"
                  style={{ color: currentColors.text }}
                >
                  {link.name}
                </a>
              ))}
            </div>
            {/* Register Now button: visible on md and up */}
            <a
              href="#register"
              className={`hidden md:inline-block px-4 py-2 rounded-lg shadow-md transition duration-300 hover:shadow-lg 
                          ${theme === 'light' ? 'hover:bg-teal-600' : 'hover:bg-teal-300'}`}
              style={{
                backgroundColor: currentColors.primary,
                color: 'white',
              }}
            >
              Register Now
            </a>
            <ThemeSwitcher theme={theme} toggleTheme={toggleTheme} />
          </div>
        </div>
      </nav>

      {/* Hero Section with animated gradient */}
      <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 overflow-hidden">
  <div className="absolute inset-0 overflow-hidden">
    <div className="absolute inset-0 opacity-20 dark:opacity-30" style={{
      background: `radial-gradient(circle at 30% 50%, ${currentColors.secondary} 0%, transparent 50%)`
    }}></div>
  </div>

  {/* Main container: column on small screens, row on medium screens and up */}
  <div className="container mx-auto px-4 flex flex-col items-center justify-center gap-12 relative z-10 md:flex-row">

    {/* Book Image with floating animation - Order for mobile first */}
    <div className="w-full flex justify-center md:w-full lg:w-1/2 md:order-2"> {/* On mobile (default), this is order-1. On md screens and up, it's order-2 to push it right. */}
      <div className="relative w-64 h-96 md:w-80 md:h-[480px] lg:w-96 lg:h-[576px] shadow-2xl rounded-xl animate-float">
        <img
          src={bookDetails.bookCoverImage}
          alt={`${bookDetails.bookTitle} Book Cover`}
          className="w-full h-full object-cover rounded-xl"
          onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/400x600/CCCCCC/333333?text=Book+Cover+Not+Found'; }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-xl"></div>
      </div>
      <div className="absolute -bottom-6 -left-6 w-32 h-32 rounded-full opacity-20" style={{
        backgroundColor: currentColors.secondary,
        filter: 'blur(40px)'
      }}></div>
    </div>

    {/* Text Content - Order for mobile first */}
    <div className="md:w-full lg:w-1/2 text-center md:text-left md:order-1"> {/* On mobile (default), this is order-2. On md screens and up, it's order-1 to push it left. */}
      <div className="inline-block px-4 py-2 mb-4 rounded-full bg-white dark:bg-gray-800 shadow-sm">
        <span className="text-sm font-semibold" style={{ color: currentColors.primary }}>Book Launch Event</span>
      </div>
      <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight mb-6 bg-clip-text text-transparent"
        style={{ backgroundImage: `linear-gradient(to right, ${currentColors.primary}, ${currentColors.secondary})` }}>
        Unlock Your True Health Potential
      </h1>
      <h2 className="text-2xl md:text-3xl font-semibold mb-8" style={{ color: currentColors.text }}>
        The <span className="font-bold" style={{ color: currentColors.primary }}>{bookDetails.bookTitle}</span> Book Launch
      </h2>
      <p className="text-lg md:text-xl mb-8 max-w-xl mx-auto md:mx-0 opacity-90" style={{ color: currentColors.text }}>
        Discover a new paradigm of health and wellness with <span className="font-bold">{bookDetails.bookTitle}</span> by {bookDetails.authorName}. This groundbreaking book blends modern science, spiritual wisdom, and integrative medicine to inspire a new model of health and wellness.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
        <a
          href={contactInfo.registrationLink}
          className="px-8 py-4 text-lg font-bold rounded-full shadow-lg transform hover:scale-105 transition duration-300 ease-in-out"
          style={{
            backgroundColor: currentColors.primary,
            color: 'white',
            boxShadow: `0 4px 14px 0 ${currentColors.primary}80`
          }}
        >
          Secure Your FREE Spot!
        </a>
        <a
          href="#highlights"
          className="px-8 py-4 text-lg font-bold rounded-full border-2 hover:bg-gray-100 dark:hover:bg-gray-800 transition duration-300"
          style={{
            borderColor: currentColors.primary,
            color: currentColors.primary
          }}
        >
          Explore Highlights
        </a>
      </div>
    </div>
  </div>
</section>

      {/* Stats Section */}
      <section className="py-12 bg-white dark:bg-gray-800 shadow-inner">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div className="p-6 rounded-xl" style={{ backgroundColor: currentColors.cardBg }}>
              <div className="text-3xl font-bold mb-2" style={{ color: currentColors.primary }}>300+</div>
              <div className="text-sm uppercase tracking-wider opacity-80">Pages</div>
            </div>
            <div className="p-6 rounded-xl" style={{ backgroundColor: currentColors.cardBg }}>
              <div className="text-3xl font-bold mb-2" style={{ color: currentColors.primary }}>10</div>
              <div className="text-sm uppercase tracking-wider opacity-80">Key Chapters</div>
            </div>
            <div className="p-6 rounded-xl" style={{ backgroundColor: currentColors.cardBg }}>
              <div className="text-3xl font-bold mb-2" style={{ color: currentColors.primary }}>50+</div>
              <div className="text-sm uppercase tracking-wider opacity-80">Research Studies</div>
            </div>
            <div className="p-6 rounded-xl" style={{ backgroundColor: currentColors.cardBg }}>
              <div className="text-3xl font-bold mb-2" style={{ color: currentColors.primary }}>100%</div>
              <div className="text-sm uppercase tracking-wider opacity-80">Holistic Approach</div>
            </div>
          </div>
        </div>
      </section>

      {/* About the Book Section */}
      <section id="about-book" className="py-16 relative overflow-hidden">
        <div className="absolute -right-20 -top-20 w-64 h-64 rounded-full opacity-10" style={{
          backgroundColor: currentColors.primary,
          filter: 'blur(60px)'
        }}></div>
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row gap-12 items-center">
            <div className="lg:w-1/2">
              <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{ color: currentColors.primary }}>
                About <span className="italic">"{bookDetails.bookTitle}"</span>
              </h2>
              <div className="space-y-4 text-lg leading-relaxed" style={{ color: currentColors.text }}>
                <p>
                  <span className="font-bold" style={{ color: currentColors.secondary }}>"Root to Cure"</span> is more than just a book; it's a profound exploration into the core principles of holistic health. {bookDetails.authorName} guides readers on a transformative journey, revealing how to achieve lasting wellness by addressing the root causes of imbalance.
                </p>
                <p>
                  This groundbreaking work offers a revolutionary new model, inspiring individuals to unlock their innate healing capabilities and cultivate a life of vibrant health.
                </p>
                <p>
                  The book synthesizes decades of clinical experience with cutting-edge research in functional medicine, creating a comprehensive roadmap to optimal wellbeing.
                </p>
              </div>
            </div>
            <div className="lg:w-1/2">
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img
                  src="https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80"
                  alt="Holistic Health"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent flex items-end p-8">
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">Holistic Health Approach</h3>
                    <p className="text-gray-200">Addressing mind, body, and spirit for complete wellness</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Book Highlights Section */}
      <section id="highlights" className="py-16 relative" style={{ backgroundColor: currentColors.cardBg }}>
        <div className="absolute -left-20 -bottom-20 w-64 h-64 rounded-full opacity-10" style={{
          backgroundColor: currentColors.secondary,
          filter: 'blur(60px)'
        }}></div>
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1 mb-3 rounded-full" style={{
              backgroundColor: `${currentColors.primary}20`,
              color: currentColors.primary
            }}>
              Book Highlights
            </span>
            <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: currentColors.primary }}>
              What You'll Discover
            </h2>
            <p className="max-w-2xl mx-auto text-lg opacity-90" style={{ color: currentColors.text }}>
              Key insights and transformative knowledge from {bookDetails.bookTitle}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {bookHighlights.map((highlight, index) => (
              <div
                key={index}
                className="group p-6 rounded-xl border hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
                style={{
                  backgroundColor: currentColors.background,
                  borderColor: currentColors.border
                }}
              >
                <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{
                  backgroundColor: `${currentColors.primary}20`,
                  color: currentColors.primary
                }}>
                  <span className="text-xl font-bold">{index + 1}</span>
                </div>
                <h3 className="text-xl font-semibold mb-3 group-hover:text-teal-600 transition-colors" style={{ color: currentColors.primary }}>
                  {highlight.title}
                </h3>
                <p className="leading-relaxed opacity-90" style={{ color: currentColors.text }}>
                  {highlight.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Author Section */}
      <section id="author" className="py-16 relative overflow-hidden">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row gap-12 items-center">
            <div className="lg:w-1/3 flex justify-center">
              <div className="relative">
                <img
                  src={bookDetails.authorImage}
                  alt={bookDetails.authorName}
                  className="w-64 h-64 md:w-80 md:h-80 rounded-full object-cover border-4 shadow-xl"
                  style={{ borderColor: currentColors.primary }}
                  onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/400x400/808080/FFFFFF?text=Author'; }}
                />
                <div className="absolute -bottom-4 -right-4 bg-white dark:bg-gray-800 px-4 py-2 rounded-full shadow-md border" style={{
                  borderColor: currentColors.border
                }}>
                  <span className="font-bold" style={{ color: currentColors.primary }}>Author</span>
                </div>
              </div>
            </div>
            <div className="lg:w-2/3">
              <span className="inline-block px-4 py-1 mb-3 rounded-full" style={{
                backgroundColor: `${currentColors.primary}20`,
                color: currentColors.primary
              }}>
                Meet The Expert
              </span>
              <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{ color: currentColors.primary }}>
                {bookDetails.authorName}
              </h2>
              <div className="prose dark:prose-invert max-w-3xl" style={{ color: currentColors.text }}>
                <p className="text-lg mb-4">
                  Prof. Dr. Mojibul Haque is a renowned expert in integrative and functional medicine with over 20 years of clinical experience. His unique approach combines evidence-based Western medicine with holistic Eastern traditions.
                </p>
                <p className="mb-4">
                  Dr. Haque holds advanced degrees in naturopathic medicine and has trained with leading experts worldwide. His research focuses on root-cause medicine and the mind-body connection in healing.
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
                  <div className="flex items-center space-x-3">
                    <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    <span>Doctor of Naturopathic Medicine</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    <span>PhD in Integrative Medicine</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    <span>20+ Years Clinical Experience</span>
                  </div>
                  <div className="flex items-center space-x-3">
                    <svg className="w-5 h-5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    <span>International Speaker</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Event Details Section */}
      <section id="event-details" className="py-16 relative overflow-hidden" style={{
        backgroundColor: currentColors.cardBg
      }}>
        <div className="absolute -right-20 -top-20 w-64 h-64 rounded-full opacity-10" style={{
          backgroundColor: currentColors.primary,
          filter: 'blur(60px)'
        }}></div>
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1 mb-3 rounded-full" style={{
              backgroundColor: `${currentColors.primary}20`,
              color: currentColors.primary
            }}>
              Join Us
            </span>
            <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: currentColors.primary }}>
              Exclusive Book Launch Event
            </h2>
            <p className="max-w-2xl mx-auto text-lg opacity-90" style={{ color: currentColors.text }}>
              Be among the first to get your copy and meet the author in person
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Date */}
            <div className="p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 group" style={{
              backgroundColor: currentColors.background
            }}>
              <div className="w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto" style={{
                backgroundColor: `${currentColors.primary}20`,
                color: currentColors.primary
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2 text-center" style={{ color: currentColors.primary }}>Date</h3>
              <p className="text-lg text-center" style={{ color: currentColors.text }}>{eventDetails.eventDate}</p>
            </div>

            {/* Time */}
            <div className="p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 group" style={{
              backgroundColor: currentColors.background
            }}>
              <div className="w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto" style={{
                backgroundColor: `${currentColors.primary}20`,
                color: currentColors.primary
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2 text-center" style={{ color: currentColors.primary }}>Time</h3>
              <p className="text-lg text-center" style={{ color: currentColors.text }}>{eventDetails.eventTime}</p>
            </div>

            {/* Venue */}
            <div className="p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300 group" style={{
              backgroundColor: currentColors.background
            }}>
              <div className="w-16 h-16 rounded-full flex items-center justify-center mb-6 mx-auto" style={{
                backgroundColor: `${currentColors.primary}20`,
                color: currentColors.primary
              }}>
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2 text-center" style={{ color: currentColors.primary }}>Venue</h3>
              <p className="text-lg text-center" style={{ color: currentColors.text }}>{eventDetails.eventVenue}</p>
            </div>
          </div>

          <div className="mt-12 p-8 rounded-xl max-w-4xl mx-auto text-center" style={{
            backgroundColor: currentColors.background,
            border: `1px solid ${currentColors.border}`
          }}>
            <h3 className="text-2xl font-semibold mb-4" style={{ color: currentColors.primary }}>Special Guests Include:</h3>
            <p className="text-lg" style={{ color: currentColors.text }}>{eventDetails.specialGuests}</p>

            <div className="mt-8 flex flex-wrap justify-center gap-4">
              {[1, 2, 3, 4, 5].map((item) => (
                <div key={item} className="w-16 h-16 rounded-full overflow-hidden bg-gray-200 dark:bg-gray-700 flex items-center justify-center">
                  <span className="text-sm font-medium">Guest {item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      {/* <section className="py-16 relative overflow-hidden">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1 mb-3 rounded-full" style={{
              backgroundColor: `${currentColors.primary}20`,
              color: currentColors.primary
            }}>
              Praise For The Book
            </span>
            <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: currentColors.primary }}>
              What Experts Are Saying
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[1, 2, 3].map((item) => (
              <div
                key={item}
                className="p-6 rounded-xl border hover:shadow-lg transition-all duration-300"
                style={{
                  backgroundColor: currentColors.cardBg,
                  borderColor: currentColors.border
                }}
              >
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 rounded-full bg-gray-300 dark:bg-gray-600 mr-4"></div>
                  <div>
                    <h4 className="font-bold" style={{ color: currentColors.primary }}>Dr. Sarah Johnson</h4>
                    <p className="text-sm opacity-70">Integrative Medicine Specialist</p>
                  </div>
                </div>
                <p className="italic" style={{ color: currentColors.text }}>
                  "This book is a game-changer in the field of holistic health. Dr. Haque's approach to root-cause medicine is both revolutionary and practical."
                </p>
                <div className="flex mt-4">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <svg key={star} className="w-5 h-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* YouTube Videos Section */}
      <section id="videos" className="py-16" style={{ backgroundColor: currentColors.cardBg }}>
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1 mb-3 rounded-full" style={{
              backgroundColor: `${currentColors.primary}20`,
              color: currentColors.primary
            }}>
              Watch & Learn
            </span>
            <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ color: currentColors.primary }}>
              Featured Videos
            </h2>
            <p className="max-w-2xl mx-auto text-lg opacity-90" style={{ color: currentColors.text }}>
              Get a preview of the concepts covered in {bookDetails.bookTitle}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {youtubeVideos.map((video) => (
              <div key={video.id} className="rounded-xl shadow-lg overflow-hidden transition-transform duration-300 hover:scale-[1.02]" style={{
                backgroundColor: currentColors.background
              }}>
                <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                  <iframe
                    className="absolute top-0 left-0 w-full h-full"
                    src={video.url.replace("youtu.be/", "www.youtube.com/embed/").split('?')[0]}
                    title={video.title}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold" style={{ color: currentColors.primary }}>{video.title}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Registration Section */}
      <section id="register" className="py-16 relative overflow-hidden text-white" style={{
        backgroundColor: currentColors.primary,
        backgroundImage: `linear-gradient(135deg, ${currentColors.primary} 0%, ${currentColors.secondary} 100%)`
      }}>
        <div className="absolute inset-0 opacity-10" style={{
          backgroundImage: 'radial-gradient(circle at 10% 20%, white 0%, transparent 20%)'
        }}></div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">Secure Your FREE Spot Today!</h2>
            <p className="text-xl max-w-3xl mx-auto">
              Seats are limited for this exclusive event. Register now to receive a <span className="font-bold">complimentary PDF copy</span> of "{bookDetails.bookTitle}" and a <span className="font-bold">rare opportunity to speak with {bookDetails.authorName}</span>!
            </p>
          </div>

          <div className="flex flex-col lg:flex-row items-center justify-center gap-12">
            {/* QR Code */}
            <div className="p-8 rounded-2xl shadow-xl flex flex-col items-center" style={{
              backgroundColor: currentColors.cardBg
            }}>
              <p className="text-lg font-semibold mb-4 text-center" style={{ color: currentColors.primary }}>
                Scan to Register
              </p>
              <img
                src={eventDetails.qrCodePlaceholder}
                alt="QR Code for Registration"
                className="w-40 h-40 rounded-lg border-2 border-gray-200"
                onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/150x150/CCCCCC/333333?text=QR+Code'; }}
              />
              <p className="text-sm mt-4 text-center max-w-xs" style={{ color: currentColors.text }}>
                (Scan this QR code with your phone's camera to register)
              </p>
            </div>

            {/* Or Divider */}
            <div className="flex items-center">
              <div className="h-px w-16 bg-white lg:h-16 lg:w-px"></div>
              <div className="px-4 font-bold">OR</div>
              <div className="h-px w-16 bg-white lg:h-16 lg:w-px"></div>
            </div>

            {/* Registration Button */}
            <div className="text-center">
              <a
                href={contactInfo.registrationLink}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-12 py-6 text-2xl font-bold rounded-full shadow-2xl hover:scale-105 transition duration-300 ease-in-out"
                style={{
                  backgroundColor: 'white',
                  color: currentColors.primary,
                  boxShadow: '0 10px 25px rgba(0,0,0,0.2)'
                }}
              >
                Click Here to Register!
              </a>
              <p className="mt-6 text-lg max-w-md">
                Registration is completely free but required due to limited seating.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="py-16 relative overflow-hidden">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row gap-12 items-center">
            <div className="lg:w-1/2">
              <h2 className="text-3xl md:text-4xl font-bold mb-6" style={{ color: currentColors.primary }}>
                Get in Touch
              </h2>
              <p className="text-lg mb-8 max-w-lg" style={{ color: currentColors.text }}>
                Have questions about the book or event? We'd love to hear from you!
              </p>

              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 mt-1">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-1" style={{ color: currentColors.primary }}>Phone</h3>
                    <a href={`tel:${contactInfo.contactNumber}`} className="hover:underline" style={{ color: currentColors.text }}>
                      {contactInfo.contactNumber}
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 mt-1">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-1" style={{ color: currentColors.primary }}>Email</h3>
                    <a href={`mailto:${contactInfo.contactEmail}`} className="hover:underline" style={{ color: currentColors.text }}>
                      {contactInfo.contactEmail}
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 mt-1">
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-1" style={{ color: currentColors.primary }}>Event Location</h3>
                    <p style={{ color: currentColors.text }}>{eventDetails.eventVenue}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="lg:w-1/2">
              <div className="bg-white dark:bg-gray-800 rounded-xl shadow-xl p-8" style={{
                border: `1px solid ${currentColors.border}`
              }}>
                <h3 className="text-2xl font-bold mb-6" style={{ color: currentColors.primary }}>Send Us a Message</h3>
                <form className="space-y-6">
                  <div>
                    <label htmlFor="name" className="block text-sm font-medium mb-1" style={{ color: currentColors.text }}>Your Name</label>
                    <input
                      type="text"
                      id="name"
                      className="w-full px-4 py-3 rounded-lg border focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition duration-300"
                      style={{
                        backgroundColor: currentColors.background,
                        borderColor: currentColors.border
                      }}
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium mb-1" style={{ color: currentColors.text }}>Email Address</label>
                    <input
                      type="email"
                      id="email"
                      className="w-full px-4 py-3 rounded-lg border focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition duration-300"
                      style={{
                        backgroundColor: currentColors.background,
                        borderColor: currentColors.border
                      }}
                    />
                  </div>
                  <div>
                    <label htmlFor="message" className="block text-sm font-medium mb-1" style={{ color: currentColors.text }}>Your Message</label>
                    <textarea
                      id="message"
                      rows="4"
                      className="w-full px-4 py-3 rounded-lg border focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition duration-300"
                      style={{
                        backgroundColor: currentColors.background,
                        borderColor: currentColors.border
                      }}
                    ></textarea>
                  </div>
                  <button
                    type="submit"
                    className="w-full px-6 py-3 rounded-lg font-bold transition duration-300 hover:opacity-90"
                    style={{
                      backgroundColor: currentColors.primary,
                      color: 'white'
                    }}
                  >
                    Send Message
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="pt-16 pb-8" style={{
        backgroundColor: currentColors.cardBg,
        borderTop: `1px solid ${currentColors.border}`
      }}>
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
            {/* Logo and About */}
            <div>
              <div className="flex items-center space-x-2 mb-4">
                <div className="w-10 h-10 rounded-full" style={{ backgroundColor: currentColors.primary }}></div>
                <h3 className="text-xl font-bold" style={{ color: currentColors.primary }}>{bookDetails.bookTitle}</h3>
              </div>
              <p className="text-sm opacity-90 mb-4" style={{ color: currentColors.text }}>
                A transformative guide to holistic health by {bookDetails.authorName}, blending science, spirituality, and integrative medicine.
              </p>
              <div className="flex space-x-4">
                {socialMediaLinks.map((link) => (
                  <a
                    key={link.name}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:opacity-80 transition-opacity duration-300"
                    style={{ color: currentColors.primary }}
                  >
                    {/* Render SVG icon from iconPath */}
                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                      <path fillRule="evenodd" d={link.iconPath} clipRule="evenodd" />
                    </svg>
                  </a>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-bold mb-4" style={{ color: currentColors.primary }}>Quick Links</h3>
              <ul className="space-y-2">
                {quickLinks.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.href}
                      className="text-sm hover:underline transition-colors duration-300 opacity-90 hover:opacity-100"
                      style={{ color: currentColors.text }}
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-lg font-bold mb-4" style={{ color: currentColors.primary }}>Contact Info</h3>
              <address className="not-italic space-y-2">
                <p className="text-sm" style={{ color: currentColors.text }}>
                  <span className="font-semibold">Email:</span> <a href={`mailto:${contactInfo.contactEmail}`} className="hover:underline">{contactInfo.contactEmail}</a>
                </p>
                <p className="text-sm" style={{ color: currentColors.text }}>
                  <span className="font-semibold">Phone:</span> <a href={`tel:${contactInfo.contactNumber}`} className="hover:underline">{contactInfo.contactNumber}</a>
                </p>
                <p className="text-sm" style={{ color: currentColors.text }}>
                  <span className="font-semibold">Event Venue:</span> {eventDetails.eventVenue}
                </p>
              </address>
            </div>

            {/* Newsletter */}
            <div>
              <h3 className="text-lg font-bold mb-4" style={{ color: currentColors.primary }}>Stay Updated</h3>
              <p className="text-sm opacity-90 mb-4" style={{ color: currentColors.text }}>
                Subscribe to get updates about the book launch and health tips.
              </p>
              <form className="flex">
                <input
                  type="email"
                  placeholder="Your email"
                  className="px-4 py-2 rounded-l-lg border-t border-b border-l focus:outline-none text-sm w-full"
                  style={{
                    backgroundColor: currentColors.background,
                    borderColor: currentColors.border
                  }}
                />
                <button
                  type="submit"
                  className="px-4 py-2 rounded-r-lg text-sm font-medium"
                  style={{
                    backgroundColor: currentColors.primary,
                    color: 'white'
                  }}
                >
                  Subscribe
                </button>
              </form>
            </div>
          </div>

          {/* Copyright */}
          <div className="mt-12 pt-8 border-t text-center" style={{ borderColor: currentColors.border }}>
            <p className="text-sm opacity-80" style={{ color: currentColors.text }}>
              © {new Date().getFullYear()} {bookDetails.bookTitle}. All rights reserved.
            </p>
            <p className="text-xs mt-1 opacity-60" style={{ color: currentColors.text }}>
              Designed with ❤️ for health and wellness.
            </p>
          </div>
        </div>
      </footer>

      {/* Floating Navigation: Now hidden on desktop (md and up) */}
      <FloatingNav quickLinks={quickLinks} currentColors={currentColors} />
    </div>
  );
}

export default Home;
